import React from 'react';
import Projects from '../components/Projects';

export default function ProjectsPage() {
  return <Projects />;
}
